<template>
  <div class="grid grid-cols-4 col-gap-4 mb-8">
    <b-field
      label="Recherche"
    >
      <b-input
        :value="filters.query"
        @input="debounceQuerySearch"
      />
    </b-field>

    <b-field
      v-for="filter in filtersForTypes[filters.type]"
      :key="filter.name"
      class="truncate"
    >
      <template slot="label">
        <div
          class="truncate"
          :title="filter.name"
        >
          {{ filter.name }}
        </div>
      </template>
      <b-select
        :value="filters[filter.filterStoreName]"
        :class="{ 'border-l-4': filters[filter.filterStoreName] }"
        class="primary-borders"
        expanded
        @input="updateFilter({ filterName: filter.filterStoreName, value: $event })"
      >
        <option :value="null">
          Tous
        </option>
        <option
          v-for="option in possibleOptionsForAttribute(filter.filterProductAttribute)"
          :key="option"
          :value="option"
        >
          {{ option }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { FILTER_FOR_TYPES } from '../../constants';


export default {
  name: 'ProductFilters',
  data() {
    return {
      filtersForTypes: FILTER_FOR_TYPES,
    };
  },
  computed: {
    ...mapFields('configuration', ['filters']),
    ...mapState('configuration', ['filters']),
    ...mapGetters('configuration', ['possibleOptionsForAttribute']),
  },
  methods: {
    ...mapMutations('configuration',
      ['updateField']),
    ...mapActions('configuration', ['updateFilter']),
    debounceQuerySearch: debounce(function update(value) {
      this.updateFilter({ filterName: 'query', value });
    }, 250),

  },
};
</script>
